import React from 'react';
import { Text, StyleSheet } from 'react-native';
import { useFormikContext } from 'formik';
import { View } from 'react-native';
import CircleButton from '../CircleButton';

type FromButtonProps = {
  title: string;
};

const FormButton = ({ title }: FromButtonProps) => {
  const { handleSubmit, isSubmitting, isValid, dirty } = useFormikContext();
  const disabled = !dirty || isSubmitting || !isValid;
  const textStyle: any[] = [styles.circleButtonText];
  if (disabled) {
    textStyle.push(styles.textDisabled);
  }
  return (
    <View style={styles.buttonContainer}>
      <CircleButton
        disabled={disabled}
        iconName={'arrow-forward'}
        onPress={handleSubmit}
      />
      <Text style={textStyle}>{title}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  buttonContainer: {
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 0,
    padding: 0,
    marginTop: 0,
  },
  circleButtonText: {
    marginTop: -10,
  },
  textDisabled: {
    color: '#dddddd',
  },
});

export default FormButton;
